@if (commentMutation.getStateOnce().isLoading) {
  <gc-loading-spinner />
} @else {
  <gc-input-field
    [label]="'reportInfo.comment.label' | translate"
    [value]="comment()"
    [renderTextArea]="true"
    [placeholder]="'reportInfo.comment.placeholder' | translate"
    [rows]="4"
    (changed)="handleOnChangeInput($event)"
  />

  @if (displayButtons()) {
    <div class="button-container">
      <app-save-buttons
        (cancel)="handleCancelEditMode()"
        (save)="handleUpdateComment()"
      />
    </div>
  }
}
